import { useEffect } from 'react';
import { useSelector } from 'src/store/store';
import { TagPageProps } from 'src/modules/tag/types';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import DefaultLayout from 'src/components/layouts/default';
import getTagPageSeo from 'src/modules/tag/seo';
import TagHeader from 'src/modules/tag/tagHeader';
import TagPostsList from 'src/modules/tag/tagPostsList';
import TagCommunitiesList from 'src/modules/tag/tagCommunitiesList';
export default function TagPage({
  longName,
  tagName,
  type
}: TagPageProps) {
  const {
    totalResults
  } = useSelector(({
    pages
  }) => pages.tag.posts);
  useEffect(() => {
    trackFootfallEvent(Event.ViewedTagPage, {
      healthTerm: tagName
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const renderResultsList = () => {
    switch (type) {
      case 'communities':
        return <TagCommunitiesList />;
      case 'posts':
      default:
        return <TagPostsList />;
    }
  };
  return <DefaultLayout isFullWidth={true} seo={getTagPageSeo(tagName, totalResults)} data-sentry-element="DefaultLayout" data-sentry-component="TagPage" data-sentry-source-file="tagPage.tsx">
      <div className="search">
        <TagHeader longName={longName} tagName={tagName} type={type} data-sentry-element="TagHeader" data-sentry-source-file="tagPage.tsx" />
        {renderResultsList()}
      </div>
    </DefaultLayout>;
}